import { InjectionToken } from '@angular/core';

export interface PromotoresAppConfig {
  production: boolean;
  debug: boolean;
  INCLUB_RIBERA_API: string;
  WALLET_MICROSERVICE_API: string;
  CMS_MICROSERVICE_API: string;
  BOOKING_MICROSERVICE_API: string;
  NIUBIZ_BUTTON_API: string;
  MERCHANT_ID: number;
  URL_BACKOFFICE_INCLUB: string;
  PROMOTIONS_RIBERA_API: string;
  ACCOUNT_MICROSERVICE_API: string;
  SECURITY_MICROSERVICE_API: string;
  PAYMENT_MICROSERVICE_API: string;
  COMMISION_MICROSERVICE_API: string;
  gtm: {
    id: string;
  };
}

export const PROMOTORES_APP_CONFIG = new InjectionToken<PromotoresAppConfig>('promotores.app.config');
